import moment from 'moment'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import { getFormattedPrice } from 'util/numbers'

const statusProps = ({ status, refunded }, themeColors) => {
  if (refunded) return { text: 'Refunded', color: themeColors.primary.brand }
  if (status === 'succeeded')
    return { text: 'Paid', color: themeColors.primary.brand }
  if (status === 'pending')
    return { text: 'Pending', color: themeColors.primary.warningText }
  return { text: 'Declined', color: themeColors.primary.negative }
}

const Item = styled('div')`
  line-height: 1.38;
  margin-bottom: 6px;
  :last-child {
    margin-bottom: 0px;
  }
  & > * {
    margin-right: 4px;
    :last-child {
      margin-right: 0px;
    }
  }
`

const Label = styled('span')`
  color: ${props => props.color};
`

const Container = styled('div')`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: ${props => props.theme.spacing['10']};
`

const Date = styled('span')`
  line-height: 1.23;
  letter-spacing: normal;
  color: ${props => props.theme.color.monochrome.mediumDark};
`
const Amount = styled('span')``

const ChargeList = ({ charges }) => {
  const { color: themeColors } = useTheme()
  return (
    <Container>
      {charges.map(charge => (
        <Item key={charge.id}>
          <Label color={statusProps(charge, themeColors).color}>
            {statusProps(charge, themeColors).text}
          </Label>
          <Amount>{getFormattedPrice(charge.amount, charge.currency)}</Amount>
          <Date>{moment.unix(charge.created).format('Do MMM YYYY')}</Date>
        </Item>
      ))}
    </Container>
  )
}

export default ChargeList
